import type { ExtendedWindow } from '@/@types/global';

declare let window: ExtendedWindow;
/**
 * Version coming from git describe
 */
export const version = window.__INFO_VERSION__?.startsWith('v')
  ? window.__INFO_VERSION__.substring(1)
  : window.__INFO_VERSION__;

if (!version) {
  console.error('__INFO_VERSION__ is not defined');
}

/**
 * Version matching the android manifest (replaced by yarn version).
 */
const APP_VERSION = '4.0.0';

if (version !== APP_VERSION) {
  console.log(`Git version (${version}) doesn't match android app version (${APP_VERSION})`);
}
